import React from 'react'
import cloneDeep from 'lodash/cloneDeep'
import { SearchInput } from '@contrast-security-inc/design-system-inputs'
import { OnInputChangeHandler } from '@contrast-security-inc/design-system-inputs/dist/types/shared'
import { CheckboxListItemType } from '../../../types'

const filterTree = (
  list: CheckboxListItemType[],
  itemToString: UseListSearchProps['itemToString'],
  searchText: string,
  subKey: UseListSearchProps['subKey']
) => {
  list.forEach((it) => {
    // @ts-ignore  we know it's one of these subkeys
    if (it?.[subKey]) {
      // @ts-ignore  we know it's one of these subkeys
      it[subKey] = filterTree(it[subKey], itemToString, searchText, subKey)
    }
  })

  return list.filter((it) =>
    !searchText
      ? true
      : // match if we have children that have already matched
        // @ts-ignore  we know it's one of these subkeys
        it?.[subKey]?.length ||
        itemToString?.(it).toLowerCase().indexOf(searchText.toLowerCase()) !== -1
  )
}

export type UseListSearchProps = {
  subKey?: 'children' | 'values'
  listItems?: CheckboxListItemType[]
  itemToString?: (it: CheckboxListItemType) => string
}

export const useListSearch = ({
  subKey = 'children',
  listItems = [],
  itemToString = (it) => it.label || it.value || ''
}: UseListSearchProps) => {
  const [searchText, setSearchText] = React.useState('')
  const onChangeSearchText: OnInputChangeHandler<string, HTMLInputElement> = React.useCallback(
    (event) => setSearchText(event.target.value),
    [setSearchText]
  )
  // create deep copy of list so we can mutate it directly in filterTree
  const searchedList = filterTree(cloneDeep(listItems), itemToString, searchText, subKey)

  return {
    searchText,
    onChangeSearchText,
    searchedList
  }
}

interface ListSearchInputProps {
  searchText: string
  onChangeSearchText: OnInputChangeHandler<string, HTMLInputElement>
  placeholder?: string
}
export const ListSearchInput = ({
  searchText,
  onChangeSearchText,
  placeholder
}: ListSearchInputProps) => {
  return (
    <SearchInput
      testId="list-search-input"
      onChange={onChangeSearchText}
      value={searchText}
      placeholder={placeholder}
    />
  )
}
